/* One route draw per section (design-system §9/§10): adds .is-drawn once when a [data-mk-reveal] section is
 * ~40% visible (less for sections taller than the viewport). Reduced motion: final state immediately. */

const sections = document.querySelectorAll('[data-mk-reveal]');
if (sections.length) {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) {
    sections.forEach((el) => el.classList.add('is-drawn'));
  } else {
    const io = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          const el = entry.target;
          const needed = Math.min(0.4, (window.innerHeight * 0.45) / Math.max(1, el.getBoundingClientRect().height));
          if (entry.isIntersecting && entry.intersectionRatio >= needed) {
            el.classList.add('is-drawn');
            io.unobserve(el);
          }
        }
      },
      { threshold: [0, 0.1, 0.2, 0.3, 0.4] }
    );
    sections.forEach((el) => io.observe(el));
  }
}
